import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import {SeatingPlanForm} from "../../api/Model";
import {inputChange, SetState} from "../../util/FormHandlers";

export function SeatingPlanFormDialog({form, setForm}: {
    form: SeatingPlanForm,
    setForm: SetState<SeatingPlanForm>,
}) {
    const handlers = useMemo(() => ({
        handleNameChange: inputChange(setForm, newValue => ({
            name: newValue,
        })),
        handleDescriptionChange: inputChange(setForm, newValue => ({
            description: newValue || null,
        })),
    }), [setForm]);

    return form ? (
        <Stack spacing={2} direction="column" sx={{pt: 2}}>
            <TextField
                required
                autoFocus
                margin="dense"
                id="name"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                value={form.name}
                onChange={handlers.handleNameChange}
            />
            <TextField
                margin="dense"
                id="description"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                multiline
                rows={3}
                value={form.description || ''}
                onChange={handlers.handleDescriptionChange}
            />
        </Stack>
    ) : null;
}
